module.exports = __webpack_public_path__ + "img/facebook-icon.c614df8b.svg";